import { Component } from 'react'
import { withRouter } from 'react-router-dom'

class ScrollToTop extends Component {
  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      const tag = document.querySelectorAll('html,body')
      for(let i=0; i<tag.length; i++) {
        tag[i].scrollTop = 0
      }
    }
  }

  render() {
    return this.props.children || null
  }
}

export default withRouter(ScrollToTop)